let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kcN39")).then(() => parcelRequire('259YH'));